var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{ref:"col",class:_vm.widthClass,style:(_vm.style),attrs:{"sm":_vm.sm,"md":_vm.md,"lg":_vm.lg,"xl":_vm.xl,"cols":_vm.xs}},[_c('component-wrapper',{attrs:{"config":_vm.component}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }